<template>
    <div>
        <info-item
            :isEnabled="isEnabled"
            :label="resource('DmVisualizer_ChangeInfo_Email')"
            @set-enabled="$emit('set-enabled', $event)"
        >
            <info-text-input 
                :placeholder="resource('DmVisualizer_ChangeInfo_Placeholder_Email')"
                :isEnabled="isEnabled"
                :value="email"
                @input="$emit('input', $event)"
            />
        </info-item>
    </div>
</template>

<script>
import resourceMixin from '../../../../Util/Mixins/resources';

import InfoItem from './InfoItem.vue';
import InfoTextInput from './Components/InfoTextInput.vue';

export default {
    name: 'info-email',
    mixins: [resourceMixin],
    components: {
        InfoItem,
        InfoTextInput
    },
    data() {
        return {
            email: ""
        };
    },
    props: {
        isEnabled: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
